module.exports = __webpack_public_path__ + "static/MatrisePro-f3a69ca73b63685c1f92a33de64346a2.woff";